export default __webpack_public_path__ + "static/media/broken-clouds-day.775f3016.svg";